// Text Block View Component (Read-only)
import React from 'react';

const TextBlockView = ({ content }) => {
  const text = content?.html || '';
  const alignment = content?.alignment || 'left';
  const fontFamily = content?.fontFamily || 'system';

  const getAlignmentClass = () => {
    switch (alignment) {
      case 'center': return 'text-center';
      case 'right': return 'text-right';
      default: return 'text-left';
    }
  };

  const getFontFamily = (fontName) => {
    if (!fontName || fontName === 'system') {
      return 'ui-sans-serif, system-ui, sans-serif';
    }
    return `"${fontName}", sans-serif`;
  };

  return (
    <div className={getAlignmentClass()} style={{ fontFamily: getFontFamily(fontFamily) }}>
      <div
        className="prose prose-lg dark:prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};

export default TextBlockView;
